export const runtimeConfig = Object.assign(import.meta.env, globalThis.bazConfig ?? {})
